import script from "./PointProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./PointProgress.vue?vue&type=script&setup=true&lang=js"

import "./PointProgress.vue?vue&type=style&index=0&id=610bfdfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610bfdfc"]])

export default __exports__